import useAuth from '@hooks/useAuth';
import { ActionIcon, CopyButton, Group, type GroupProps } from '@mantine/core';
import { IconCheck, IconCopy } from '@tabler/icons-react';
import { getErrorDetails } from '@util/errors';

export interface ErrorTitleProps extends GroupProps {
  error: unknown;
}

export default function ErrorTitle({ error, children, ...props }: ErrorTitleProps) {
  const { user } = useAuth();
  const errorDetails = getErrorDetails(error, user);

  return (
    <Group justify="space-between" {...props}>
      <span css={{ whiteSpace: 'pre-wrap' }}>{children}</span>

      <CopyButton value={errorDetails}>
        {({ copy, copied }) => <ActionIcon onClick={copy}>{copied ? <IconCheck /> : <IconCopy />}</ActionIcon>}
      </CopyButton>
    </Group>
  );
}
